import { CircleAlert } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

interface ErrorAlertProps {
  readonly title: string;
  readonly children?: ReactNode;
  /** Request ID shown as "Reference" so a problem can be traced (NFR-6). */
  readonly reference?: string | undefined;
  readonly className?: string;
}

export function ErrorAlert({ title, children, reference, className }: ErrorAlertProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex gap-3 rounded-sm border border-destructive/30 bg-destructive/5 p-3 text-sm',
        className,
      )}
    >
      <CircleAlert className="mt-0.5 size-4 shrink-0 text-destructive" aria-hidden />
      <div className="flex flex-col gap-1">
        <p className="font-medium text-foreground">{title}</p>
        {children && <div className="text-muted-foreground">{children}</div>}
        {reference && <p className="text-xs text-muted-foreground">Reference: {reference}</p>}
      </div>
    </div>
  );
}
